import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { Rekening, RekeningvalidatieResultaat } from './rekeningvalidatie.model';

@Injectable({ providedIn: 'root' })
export class RekeningvalidatieResource {
    private readonly httpClient = inject(HttpClient);

    private readonly baseUrl: string = '/services/apic-rekeningvalidatie/api';
    private _apiKey: string = '{<APIC-REKENINGVALIDATIE-API-KEY>}';

    get apiKey() {
        return this._apiKey;
    }

    set apiKey(apiKey: string) {
        this._apiKey = apiKey;
    }

    public getRekeningvalidatieResultaat(rekening: Rekening): Observable<RekeningvalidatieResultaat> {
        return this.httpClient.post<RekeningvalidatieResultaat>(`${this.baseUrl}/rekeningvalidaties`, rekening, {
            headers: this.getHeaders()
        });
    }

    private getHeaders(): HttpHeaders {
        return new HttpHeaders().set('X-Api-Key', this.apiKey);
    }
}
